import * as React from "react"

export type Toast = {
  id: string
  title?: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
  duration?: number
}

type ToastReturn = {
  toasts: Toast[]
  toast: (t: Omit<Toast, "id">) => { id: string }
  dismiss: (id?: string) => void
}

const listeners = new Set<(toasts: Toast[]) => void>()
let state: Toast[] = []

function emit() {
  for (const l of listeners) l(state)
}

export function useToast(): ToastReturn {
  const [toasts, setToasts] = React.useState<Toast[]>(state)

  React.useEffect(() => {
    const l = (s: Toast[]) => setToasts(s)
    listeners.add(l)
    return () => void listeners.delete(l)
  }, [])

  const toast = React.useCallback((t: Omit<Toast, "id">) => {
    const id = crypto.randomUUID()
    state = [...state, { id, ...t }]
    emit()
    return { id }
  }, [])

  const dismiss = React.useCallback((id?: string) => {
    state = id ? state.filter((x) => x.id !== id) : []
    emit()
  }, [])

  return { toasts, toast, dismiss }
}
